import gql from 'graphql-tag'

import { OFFERING_ADDONS_FIELDS } from './rsvpQueries'
import { PACKAGE_ADDONS_FIELDS, IMAGE_FIELDS_FRAG } from './general'

export const GET_EVENT = gql`
  query getEvent($customUrl: String!) {
    getEvent(customUrl: $customUrl) {
      id
      name
      description
      defaultKidsAllowed
      brideFirstName
      brideLastName
      groomFirstName
      groomLastName
      video
      invitationTemplate {
        template
      }
      host {
        avatarUrl
        firstName
        lastName
      }
    }
  }
`

const PROVIDER_FIELDS_FRAG = gql`
  fragment ProviderFieldsPublic on Provider {
    id
    name
    url
    mainImage {
      ...ImageFields
    }
    images {
      ...ImageFields
    }
    address
    location
    coord
    bookAllRequired
    description
    airportCode
    timeToAirport
    metadata
    accomodationTaxRate
    venueTaxRate
  }
  ${IMAGE_FIELDS_FRAG}
`
const ROOM_FIELDS_FRAG = gql`
  fragment RoomFieldsPublic on RoomOffering {
    description
    id
    images {
      ...ImageFields
    }
    intro
    mainImage {
      ...ImageFields
    }
    name
    price
    provider {
      ...ProviderFieldsPublic
    }
    quantity
    room {
      beds
      occupancy
      size
      basic
    }
    addOns {
      ...OfferingAddonsFields
    }
  }
  ${PROVIDER_FIELDS_FRAG}
  ${OFFERING_ADDONS_FIELDS}
`
const PACKAGE_FIELDS_FRAG = gql`
  fragment PackageFieldsPublic on PackageOffering {
    id
    name
    intro
    price
    description
    images {
      ...ImageFields
    }
    mainImage {
      ...ImageFields
    }
    package {
      baseGuestNumber
      basePrice
      minimumGuests
      basic
    }
    provider {
      ...ProviderFieldsPublic
    }
    quantity
    addOns {
      ...OfferingAddonsFields
    }
  }
  ${PROVIDER_FIELDS_FRAG}
  ${OFFERING_ADDONS_FIELDS}
`

export const GET_EVENT_COMPONENTS_PUBLIC = gql`
  query getEventComponentsPublic($eventId: ID!) {
    getEventComponents(eventId: $eventId) {
      eventId
      main
      capacity
      bookingCount
      date
      duration
      id
      alias
      deadline
      guestPays
      order
      customTexts
      details
      offering {
        __typename
        ... on PackageOffering {
          ...PackageFieldsPublic
        }
        ... on RoomOffering {
          ...RoomFieldsPublic
        }
      }
      main
      items {
        price
        deleted
        master
      }
      tiers {
        id
        name
      }
      packageCustomization {
        ...PackageAddonsFields
      }
    }
  }
  ${PACKAGE_FIELDS_FRAG}
  ${ROOM_FIELDS_FRAG}
  ${PACKAGE_ADDONS_FIELDS}
`

export const GET_MAGIC_LINK = gql`
  query getMagicLink($email: String!, $event: String!) {
    getMagicLink(email: $email, event: $event) {
      message
    }
  }
`
